import * as React from 'react'
import { cva } from 'class-variance-authority'
import { cn } from '@/lib/utils'

export interface SegmentedToggleProps {
  /** Valor actualmente seleccionado */
  value: string
  /** Callback que se ejecuta al cambiar la opción */
  onChange: (value: string) => void
  /** Opciones del toggle */
  options: string[]
  /** Clases adicionales para el contenedor */
  className?: string
  /** Deshabilita el componente */
  disabled?: boolean
}

const buttonVariants = cva(
  'px-2.5 h-full text-[12px] font-semibold rounded-md transition-all duration-150 cursor-pointer border-none leading-none disabled:opacity-50 disabled:cursor-not-allowed',
  {
    variants: {
      active: {
        true: 'bg-surface-0 text-primary shadow-sm',
        false: 'bg-transparent text-tertiary hover:text-secondary',
      },
    },
  }
)

export const SegmentedToggle = React.forwardRef<HTMLDivElement, SegmentedToggleProps>(
  ({ value, onChange, options, className, disabled = false }, ref) => {
    return (
      <div
        ref={ref}
        role="group"
        className={cn(
          'inline-flex items-center gap-px bg-surface-pressed rounded-lg p-[2px] h-6',
          className
        )}
      >
        {options.map((option) => (
          <button
            key={option}
            type="button"
            disabled={disabled}
            onClick={() => onChange(option)}
            className={cn(buttonVariants({ active: value === option }))}
            aria-pressed={value === option}
          >
            {option}
          </button>
        ))}
      </div>
    )
  }
)

SegmentedToggle.displayName = 'SegmentedToggle'


